import { getCustomerBookings } from '../../apis'
import Location from '../../assets/images/accomodationcard.png'
import Loader from '../../components/elements/Loader'
import Modal from '../../components/elements/Modal'
import { useFetch } from '../../hooks/useFetch'
import { dateFormat } from '../../utils'

export default () => {
    const [bookings,,loading] = useFetch(getCustomerBookings, [])
    return (
        <section>
            <Loader loading={loading} />
            {
                bookings?.map(( hotel, i ) =>
                    <div className="w-100 " key={i}>
                        <div className="card rounded-4 d-flex flex-row my-2 booking-card">
                            <div className='image-wrapper'>
                                <img src={hotel.files?.at(0)?.Url || Location} className='w-100 h-100 image-cover image' />
                            </div>
                            <div className='p-3 w-100'>
                                <h4 className='custom-text-color'>{ hotel.name }</h4>
                                <div className='d-flex justify-content-between align-items-end flex-wrap w-100'>
                                    <div>
                                        <p className='mb-3 custom-text-color fs-8 bold'>{ hotel.city } | { hotel.state }</p>
                                        <p className='mb-0 fs-9'>Check In</p>
                                        <p className='custom-text-color bold mb-0'>{ dateFormat(hotel.checkInDate )}</p>
                                    </div>

                                    <div>
                                        <p className='mb-3 text-saffron fs-8 bold'>Booking Status: <span className={`${ hotel.bookingStatus == "success" ? "text-success" : "text-danger" }`}>{ hotel.bookingStatus }</span></p>

                                        <p className='mb-0 fs-9'>Check Out</p>
                                        <p className='custom-text-color bold mb-0'>{ dateFormat(hotel.checkOutDate )}</p>
                                    </div>

                                    <div>
                                        <p className='mb-0 fs-9'>Room</p>
                                        <p className='custom-text-color bold mb-0'>{ hotel?.roomId?.roomCategoryId?.name }</p>
                                    </div>

                                    <div className='d-flex flex-column justify-content-between mt-2 w-sm-100'>
                                        <button className='primary-btn px-4 mb-2'>Cancel Trip</button>
                                        <button className='primary-btn px-4 bg-primary border-0'>Reschedule</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {false && <Modal open={false}>
                <div className='p-4'>
                    <h4 className='custom-text-color'>Are you sure to cancel this trip?</h4>
                    <p className='fs-9'>Check your email for a booking confirmation.</p>
                    <div className="w-100 mt-4">
                        <p className='mb-2 fs-9'>Choose the reason for trip cancellation</p>
                        <select className=" form-control rounded-5 borderless bg-transparent" >
                            <option>Select the reason</option>
                        </select>
                    </div>

                    <div className='w-100 mt-4'>
                        <p className='mb-2 fs-9'>Other reason</p>
                        <textarea className='form-control' placeholder='Write here..'></textarea>
                    </div>

                    <div className='d-flex mt-5'>
                        <button className='secondary-btn w-50 m-2'>Cancel</button>
                        <button className='primary-btn w-50 m-2'>Cancel</button>
                    </div>
                </div>
            </Modal>}

            {false && <Modal open={false}>
                <div className='p-4'>
                    <h4 className='custom-text-color'>Cancel Trip</h4>
                    <p className='fs-8'>Check your email for a booking confirmation.</p>

                    <ul>
                        <li className='mb-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore, maiores.</li>
                        <li className='mb-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore, maiores.</li>
                        <li className='mb-2'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore, maiores.</li>
                    </ul>

                    <div className='d-flex mt-5'>
                        <button className='secondary-btn w-50 m-2'>Cancel</button>
                        <button className='primary-btn w-50 m-2'>Cancel Trip</button>
                    </div>
                </div>
            </Modal>}
        </section>
    )
}